export enum AuthErrorCodeEnum {
  INVALID_CREDENTIALS = "INVALID_CREDENTIALS",
  TOKEN_EXPIRED = "TOKEN_EXPIRED",
  SESSION_ENDED = "SESSION_ENDED",
}
